import { getExamplePictures } from '@/api/example-pictures'
import {
  SET_LIST_EXAMPLE_PICTURE
} from '@/store/mutation-types'

const fetchListExamplePictures = ({commit, dispatch}, params = {limit: 18}) => {
  getExamplePictures(params).then(async function (response) {
    switch (response.code) {
      case 200:
        commit(SET_LIST_EXAMPLE_PICTURE, response.data)
        break
      default:
        break
    }
  })
}

export default {
  fetchListExamplePictures
}



// WEBPACK FOOTER //
// ./src/components/example-picture/store/actions.js